export const saleTicketSummary = (zone, courtesy = false) => {
  const quantity = Number(zone.quantity) || 0
  const active = Boolean(zone.has_2x1) && !courtesy
  const general = Number(zone.id_type_event_zone) === 1
  const tickets = active && general ? quantity * 2 : quantity
  const free = active ? Math.floor(tickets / 2) : 0
  return { tickets, free, paid: tickets - free, total: courtesy ? 0 : (tickets - free) * Number(zone.price_event_zone) }
}

export const maxPaidTickets = (zone, courtesy = false) => {
  const available = zone.event_zone_detail?.length || 0
  return zone.has_2x1 && !courtesy && Number(zone.id_type_event_zone) === 1 ? Math.floor(available / 2) : available
}

export const generalTicketSummary = (zone, quantity) =>
  saleTicketSummary({ ...zone, id_type_event_zone: 1, quantity })

export const generalPaidLimit = (available, active) =>
  Math.min(active ? Math.floor(available / 2) : available, active ? 15 : 30)
